import { isInternalPlatformURL } from '@Src/commons/Utils/authUtils';

const BASE_TITLE = 'Next by Bizongo';
const INTERNAL_TITLE = 'Bizongo Internal';
const updateTitle = () => {
  const path = window.location.pathname;
  let title = 'Loading...';
  const subtitle = isInternalPlatformURL() ? INTERNAL_TITLE : BASE_TITLE;

  const pathArr = path.split('/');
  // console.log('ashis', path, pathArr);

  if (pathArr?.[1] === 'app') {
    if (pathArr?.[2] === 'catalog') {
      title = `Catalog - ${subtitle}`;
      if (pathArr?.[3] === 'products') {
        title = `Products - ${subtitle}`;
      } else if (pathArr?.[3] === 'raw-materials') {
        title = `Raw Materials - ${subtitle}`;
      } else if (pathArr?.[3] === 'categories') {
        title = `Categories - ${subtitle}`;
      }
    } else if (pathArr?.[2] === 'vendor') {
      title = `Vendors - ${subtitle}`;
    } else if (pathArr?.[2] === 'network') {
      title = `Networks - ${subtitle}`;
    } else if (pathArr?.[2] === 'bidding') {
      title = `Bidding - ${subtitle}`;
      if (pathArr?.[3] === 'incoming') {
        title = `Incoming Bids - ${subtitle}`;
      } else if (pathArr?.[3] === 'outing') {
        title = `Outgoing Bids - ${subtitle}`;
      }
    } else if (pathArr?.[2] === 'orders') {
      title = `Orders - ${subtitle}`;
      if (pathArr?.[3] === 'purchase') {
        title = `Purchase Orders - ${subtitle}`;
      } else if (pathArr?.[3] === 'sale') {
        title = `Sales Orders - ${subtitle}`;
      } else if (pathArr?.[3] === 'create') {
        title = `Create Order - ${subtitle}`;
      }
    } else if (pathArr?.[2] === 'deliveries') {
      title = `Orders - ${subtitle}`;
      if (pathArr?.[3] === 'inbound') {
        title = `Inbound Deliveries - ${subtitle}`;
      } else if (pathArr?.[3] === 'outbound') {
        title = `Outbound Deliveries - ${subtitle}`;
      }
    } else if (pathArr?.[2] === 'invoices') {
      title = `Invoices - ${subtitle}`;
      if (pathArr?.[3] === 'buyer') {
        title = `Purchase Invoices - ${subtitle}`;
      } else if (pathArr?.[3] === 'seller') {
        title = `Sales Invoices - ${subtitle}`;
      } else if (pathArr?.[3] === 'insta' || pathArr?.[4] === 'insta') {
        title = `Insta Invoices - ${subtitle}`;
      } else if (pathArr?.[3] === 'create') {
        title = `Create Invoices - ${subtitle}`;
        if (pathArr?.[4] === 'e-invoice') {
          title = `Create e-invoice - ${subtitle}`;
        } else if (pathArr?.[4] === 'invoice') {
          title = `Create Invoice - ${subtitle}`;
        } else if (pathArr?.[4] === 'credit-note') {
          title = `Create Credit Note - ${subtitle}`;
        } else if (pathArr?.[4] === 'debit-note') {
          title = `Create Debit Note - ${subtitle}`;
        }
      } else if (pathArr?.[3] === 'finpaas') {
        title = `FinPaaS Invoices - ${subtitle}`;
      }
    } else if (pathArr?.[2] === 'finance') {
      title = `Invoices - ${subtitle}`;
      if (pathArr?.[3] === 'purchases') {
        title = `Finance Purchases - ${subtitle}`;
      } else if (pathArr?.[3] === 'sales') {
        title = `Finance Sales - ${subtitle}`;
      } else if (pathArr?.[3] === 'creditApplication') {
        title = `Credit Application - ${subtitle}`;
      }
    } else if (pathArr?.[2] === 'reports') {
      title = `Reports - ${subtitle}`;
      if (pathArr?.[3] === 'purchases-report') {
        title = `Purchase Reports - ${subtitle}`;
      } else if (pathArr?.[3] === 'sales-report') {
        title = `Sales Reports - ${subtitle}`;
      }
    } else if (pathArr?.[2] === 'support') {
      title = `Help and Support - ${subtitle}`;
    } else if (pathArr?.[2] === 'profile') {
      title = `Profile - ${subtitle}`;
    } else if (pathArr?.[2] === 'organisation-profile') {
      title = `Organisation Profile - ${subtitle}`;
    } else if (pathArr?.[2] === 'team') {
      title = `Team - ${subtitle}`;
    } else if (pathArr?.[2] === 'addresses') {
      title = `Addresses - ${subtitle}`;
    } else if (pathArr?.[2] === 'admin_details') {
      title = `Admin Details - ${subtitle}`;
    } else if (pathArr?.[2] === 'company_details') {
      title = `Company Details - ${subtitle}`;
    } else if (pathArr?.[2] === 'onboarding') {
      title = `Onboarding - ${subtitle}`;
    } else if (pathArr?.[2] === 'create-invoice') {
      title = `Create Invoice - ${subtitle}`;
    } else if (pathArr?.[2] === 'pre-screening') {
      title = `Pre Screening - ${subtitle}`;
    } else if (pathArr?.[2] === 'releases') {
      title = `Releases - ${subtitle}`;
    }
  } else if (pathArr?.[1] === 'auth') {
    if (pathArr?.[2] === 'login') {
      title = `Login - ${subtitle}`;
    } else if (pathArr?.[2] === 'forgot-password') {
      title = `Forgot Password - ${subtitle}`;
    } else if (pathArr?.[2] === 'sign-up') {
      title = `SignUp - ${subtitle}`;
    } else if (pathArr?.[2] === 'reset-password') {
      title = `Reset Password - ${subtitle}`;
    }
  } else if (pathArr?.[1] === 'sessions-expired') {
    title = 'Manage Sessions';
  }

  document.title = title;
  return title;
};

export default updateTitle;
